import { callExternalApi } from "../../../services/external-api.service";
import { IAdvisorLedgerResponse } from "../../../../types/database";

class AdvisorShareHttpClient {
    private _apiServerUrl: string;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }

    async getAdvisorLedger(accessToken: string, advisorId: string, projectTag?: string): Promise<{ data: IAdvisorLedgerResponse | null, error: any }> {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/shares/my/ledger`,
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "content-type": "application/json"
            }
        };
        const { data, error } = await callExternalApi({ config });
        return {
            data: data.data || null,
            error
        };
    }
}

export default AdvisorShareHttpClient; 